
export const STASH_PAGE_STATE = 'OD/STASH_PAGE_STATE'
export const UNSTASH_PAGE_STATE = 'OD/UNSTASH_PAGE_STATE'


interface PageStashPayload {
  readonly path: string,
  readonly states: any,
}

export interface StashPageStateAction {
  readonly type: typeof STASH_PAGE_STATE;
  readonly payload: PageStashPayload;
}

export interface UnstashPageStateAction {
  readonly type: typeof UNSTASH_PAGE_STATE;
  readonly path: string;
}

export const raiseStashPageState = (path:string, states: any): StashPageStateAction => ({
  type: STASH_PAGE_STATE,
  payload: { path, states },
})

export const raiseUnstashPageState = (path:string): UnstashPageStateAction => ({
  type: UNSTASH_PAGE_STATE,
  path,
})

